module.exports = __webpack_public_path__ + "static/media/Logo_12weeks_en.93d6cd40.svg";